import React, { useEffect, useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Zap, Star, Check, Info, CreditCard, ArrowRight } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import { getCreditBalance } from '../../lib/api';
import { CreditPurchase } from '../payments/CreditPurchase';
export function UsageCard() {
  const {
    user
  } = useUser();
  const [credits, setCredits] = useState(0);
  const [loadingCredits, setLoadingCredits] = useState(true);
  const [showPurchase, setShowPurchase] = useState(false);
  useEffect(() => {
    loadCredits();
  }, []);
  const loadCredits = async () => {
    setLoadingCredits(true);
    try {
      const balance = await getCreditBalance();
      setCredits(balance);
    } catch (error) {
      console.error('Error loading credits:', error);
      // If endpoint doesn't exist yet, default to 0
      setCredits(0);
    } finally {
      setLoadingCredits(false);
    }
  };
  // Calculate remaining credits (for free users)
  const freeCreditsTotal = 3;
  const remainingCredits = user?.plan.isPro ? 'Unlimited' : Math.max(0, freeCreditsTotal - (user?.usage.minutesUsed || 0));
  return <Card className="mb-6 overflow-hidden" data-id="element-66">
      <CardContent className="p-0" data-id="element-67">
        <div className="bg-gradient-to-r from-primary/10 to-primary/5 p-4 border-b border-border/20" data-id="element-68">
          <div className="flex items-center justify-between" data-id="element-69">
            <h3 className="text-lg font-medium flex items-center" data-id="element-70">
              <Zap size={18} className="text-primary mr-2" data-id="element-71" />
              Your Credits
            </h3>
            {user?.plan.isPro ? <span className="bg-primary/20 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-72">
                Unlimited Plan
              </span> : <span className="bg-secondary/70 text-secondary-foreground px-3 py-1 rounded-full text-sm" data-id="element-73">
                {credits} Credits
              </span>}
          </div>
        </div>

        <div className="p-4" data-id="element-74">
          {/* Usage Display */}
          {!user?.plan.isPro && <div className="mb-4" data-id="element-75">
              <div className="flex justify-between items-center mb-2" data-id="element-76">
                <span className="text-sm text-muted-foreground" data-id="element-77">
                  Credits Available
                </span>
                <span className="font-medium text-lg" data-id="element-78">{credits}</span>
              </div>
            </div>}

          {/* Low Credits Warning */}
          {!user?.plan.isPro && credits <= 5 && <div className="mb-4 p-3 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800/50 rounded-lg text-amber-800 dark:text-amber-300 text-sm flex items-start" data-id="element-79">
              <Info size={16} className="mr-2 mt-0.5 flex-shrink-0" data-id="element-80" />
              <p data-id="element-81">
                {credits === 0 ? "You're out of credits! Purchase more to continue using comment analysis." : `You have ${credits} credits remaining. Each credit covers 100 comments.`}
              </p>
            </div>}

          {/* Show Purchase Options or Link to Settings */}
          {!user?.plan.isPro && !showPurchase && <div className="space-y-3" data-id="element-82">
              <Button className="w-full" onClick={() => setShowPurchase(true)} data-id="element-83">
                <CreditCard size={16} className="mr-2" data-id="element-84" />
                Buy Credits
              </Button>
              <Link to="/app/settings" className="block" data-id="element-85">
                <Button variant="outline" className="w-full" data-id="element-86">
                  <ArrowRight size={16} className="mr-2" data-id="element-87" />
                  View All Options in Settings
                </Button>
              </Link>
            </div>}

          {/* Inline Purchase Component */}
          {!user?.plan.isPro && showPurchase && <div className="space-y-4" data-id="element-88">
              <div className="flex items-center justify-between mb-2" data-id="element-89">
                <h4 className="font-medium" data-id="element-90">Purchase Credits</h4>
                <Button variant="ghost" size="sm" onClick={() => setShowPurchase(false)} data-id="element-91">
                  Close
                </Button>
              </div>
              <CreditPurchase currentCredits={credits} onPurchaseComplete={() => {
            loadCredits();
            setShowPurchase(false);
          }} data-id="element-92" />
            </div>}

          {/* Pro Plan Benefits */}
          {user?.plan.isPro && <div className="bg-primary/10 rounded-lg p-4 border border-primary/30" data-id="element-93">
              <h4 className="flex items-center font-medium mb-2" data-id="element-94">
                <Star size={16} className="text-primary mr-2" data-id="element-95" />
                Your Unlimited Plan Benefits
              </h4>
              <ul className="text-sm grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-96">
                <li className="flex items-start" data-id="element-97">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-98" />
                  <span data-id="element-99">Unlimited transcriptions</span>
                </li>
                <li className="flex items-start" data-id="element-100">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-101" />
                  <span data-id="element-102">Priority processing</span>
                </li>
                <li className="flex items-start" data-id="element-103">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-104" />
                  <span data-id="element-105">Advanced analytics</span>
                </li>
                <li className="flex items-start" data-id="element-106">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-107" />
                  <span data-id="element-108">Premium support</span>
                </li>
              </ul>
            </div>}
        </div>
      </CardContent>
    </Card>;
}